import { Component, OnInit, inject } from '@angular/core';

import { AnchorDirective, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { BehaviorDataService } from '../../service/behaviorData.service';
import { DepositService } from '../../service/deposit.service';
import { GtmService } from '../../service/gtm.service';

@Component({
    selector: 'app-od-popup',
    imports: [TranslateModule, AnchorDirective],
    templateUrl: './od-popup.component.html',
})
export class OdPopupComponent implements OnInit {
    depositService = inject(DepositService);
    private behaviorData = inject(BehaviorDataService);
    private GTMService = inject(GtmService);

    private navigationService = inject(NavigationService);
    ngOnInit(): void {
        this.GTMService.raiseEventForODbannerLoad('complete your profile interceptor-under 2k');
    }
    close(btnName: any) {
        this.GTMService.raiseEventForODbannerClicks('close', 'complete your profile interceptor-under 2k', btnName, 'not applicable');
        this.depositService.showODpopUp.set(false);
    }
    redirectToODpage() {
        const url = this.behaviorData.userODetails?.urlInfo?.url;
        this.GTMService.raiseEventForODbannerClicks('click', 'complete your profile interceptor-under 2k', 'share details', url);
        this.navigationService.goTo(url, { forceReloadTarget: 'top' });
    }
}
